import { GetterTree } from "vuex";
import { RootState } from "../types";
import { EvaluationsInterface } from "./types";
export const getters: GetterTree<EvaluationsInterface, RootState> = {};
